module.exports = __webpack_public_path__ + "static/media/termostat_nm.d61ff928.pdf";